/**
 * Lib.Common: Table component declarations
 */


import ibTransitionCollapse from './ib-transition-collapse.vue';
import ibTransitionFade     from './ib-transition-fade.vue';
import ibTransitionSlide    from './ib-transition-slide.vue';


export default [
    ibTransitionCollapse,
    ibTransitionFade,
    ibTransitionSlide
];
